/** @jsx jsx */
import { jsx } from '@emotion/core'
import { styles } from './styles'
import { FunctionComponent, InputHTMLAttributes, ReactElement } from 'react'

// @ts-ignore
interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string | ReactElement
  checked: boolean
  onChange: (checked: boolean) => any
  bold?: boolean
}

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  label,
  checked,
  onChange,
  bold,
  ...props
}) => (
  <div css={styles.item} onClick={() => onChange(!checked)}>
    <input css={styles.input} checked={checked} type="checkbox" {...props} />
    <span css={[styles.label, bold && styles.labelBold]}>{label}</span>
  </div>
)
